import { ERecouvrement } from "./enum/recouvrement";

export class IBMRSubstrat {

    VaseLimon: ERecouvrement = ERecouvrement.Absent;
    PierreGalet: ERecouvrement = ERecouvrement.Absent;
    SableGravier: ERecouvrement = ERecouvrement.Absent;
    TerreArgileMarne: ERecouvrement = ERecouvrement.Absent;
    BlocDalle: ERecouvrement = ERecouvrement.Absent;
    DebrisOrganique: ERecouvrement = ERecouvrement.Absent;
    Artificiel: ERecouvrement = ERecouvrement.Absent;
    RacineBranchage: ERecouvrement = ERecouvrement.Absent;
    Autre: ERecouvrement = ERecouvrement.Absent;
    AutreDescription: string;

    static mapFromJSON(json): IBMRSubstrat {
        const s = new IBMRSubstrat();

        s.VaseLimon = json.vaseLimon;
        s.PierreGalet = json.pierreGalet;
        s.SableGravier = json.sableGravier;
        s.TerreArgileMarne = json.terreArgileMarne;
        s.BlocDalle = json.blocDalle;
        s.DebrisOrganique = json.debrisOrganique;
        s.Artificiel = json.artificiel;
        s.RacineBranchage = json.racineBranchage;
        s.Autre = json.autre;
        s.AutreDescription = json.autreDescription;

        return s;
    }
}